export const languageMessages = (language:string, key: string) => {
    const messages: any = {
      en: {
        payingForPolicy: 'Who is paying for the policy?',
        payingForPolicyOptions: [
          { value: '1', label: 'Policy owner / Insured' },
          { value: '2', label: 'Relative' },
          { value: '3', label: 'Other' },
        ],
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone Number',
        country: 'Country',
        state: 'State / Region',
        city: 'City',
        zipCode: 'Zip Code',
        billingAddress: 'Billing Address',
        relationship: 'What’s the relationship between the paymaster and the insured?',
        selectOption: 'Select',
        authorizeRecurrence: 'I authorize recurring payments.',
        payNow: 'Pay Now',
        validationFields: 'Complete the requested fields.',
        payerInformation: 'Payer Information',
        paymentMethodTitle: 'Payment Method Information',
        searchCountry: 'Search Country',
        searchState: 'Search State',
        searchCity: 'Search City',
        paymentCurrencyReminder: 'Remember that the payment for your life insurance will be made in **dollars (USD)**',
      },
      es: {
        payingForPolicy: '¿Quién está pagando por esta póliza?',
        payingForPolicyOptions: [
          {
            value: '1',
            label: 'Titular de la póliza / Asegurado',
          },
          {
            value: '2',
            label: 'Pariente',
          },
          {
            value: '3',
            label: 'Otro',
          },
        ],
        firstName: 'Primer nombre',
        middleName: 'Segundo nombre',
        lastName: 'Apellidos',
        email: 'Correo Electrónico',
        phone: 'Número de teléfono',
        country: 'País',
        state: 'Estado / Región',
        city: 'Ciudad',
        zipCode: 'Código postal',
        billingAddress: 'Dirección de facturación',
        relationship: '¿Qué relación existe entre el pagador y el asegurado?',
        selectOption: 'Seleccione',
        authorizeRecurrence: 'Autorizo pagos recurrentes.',
        payNow: 'Pagar ahora',
        validationFields: 'Complete los campos solicitados.',
        payerInformation: 'Información del Pagador',
        paymentMethodTitle: 'Información sobre el método de pago',
        searchCountry: 'Buscar país',
        searchState: 'Buscar estado',
        searchCity: 'Buscar ciudad',
        paymentCurrencyReminder: 'Recuerda que el pago de tu seguro de vida se realizará en **dólares (USD)**',
      },
      pt: {
        payingForPolicy: 'Quem etá pagando por esta apólice?',
        payingForPolicyOptions: [
          {
            value: '1',
            label: 'Titular da apólice / Segurado',
          },
          {
            value: '2',
            label: 'Relativo',
          },
          {
            value: '3',
            label: 'Outro',
          },
        ],
        firstName: 'Primeiro nome',
        middleName: 'Nome do meio',
        lastName: 'Sobrenomes',
        email: 'Correio eletrônico',
        phone: 'Número de telefone',
        country: 'País',
        state: 'Estado / Região',
        city: 'Cidade',
        zipCode: 'Código postal',
        billingAddress: 'Endereço de cobrança',
        relationship: 'Qual a relação entre o pagador e o garantido?',
        selectOption: 'Selecione',
        authorizeRecurrence: 'Autorizo pagamentos recorrentes.',
        payNow: 'Pagar agora',
        validationFields: 'Preencha os campos solicitados.',
        payerInformation: 'Informações do Pagador',
        paymentMethodTitle: 'Informações sobre o método de pagamento',
        searchCountry: 'Pesquisar país',
        searchState: 'Pesquisar estado',
        searchCity: 'Pesquisar cidade',
        paymentCurrencyReminder: 'Lembre-se de que o pagamento do seu seguro de vida será feito em **dólares (USD)**',
      },
    }
    return messages[language][key];
  };